export default "__VITE_ASSET__Cw6OAw6A__"